var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "auth-saas auth-saas--pro", attrs: { id: "wrapper" } },
    [
      _c(
        "div",
        { staticClass: "auth-saas__layout auth-saas__layout--centered" },
        [
          _c("div", { staticClass: "auth-saas__form-column" }, [
            _c("div", { staticClass: "auth-saas__form-inner" }, [
              _c("div", { staticClass: "auth-saas__card" }, [
                _c("div", { staticClass: "auth-saas__user" }, [
                  _c("img", {
                    staticClass: "auth-saas__avatar",
                    attrs: {
                      src: _vm.getAuthUser("avatar"),
                      width: "72",
                      height: "72",
                      alt: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "auth-saas__user-name" }, [
                    _vm._v(_vm._s(_vm.getAuthUser("full_name"))),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("h1", { staticClass: "auth-saas__title text-center" }, [
                  _vm._v(_vm._s(_vm.trans("auth.password"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "auth-saas__subtitle text-center" }, [
                  _vm._v(
                    "Enter your password to unlock the admin panel and continue where you left off."
                  ),
                ]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "form-validate is-alter",
                    attrs: { id: "lockScreenForm" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submit.apply(null, arguments)
                      },
                      keydown: function ($event) {
                        return _vm.lockScreenForm.errors.clear(
                          $event.target.name
                        )
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "auth-saas__label",
                            attrs: { for: "lock-password" },
                          },
                          [_vm._v(_vm._s(_vm.trans("auth.password")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "auth-saas__input-wrap" },
                          [
                            _c("admin-icon", {
                              attrs: { name: "lock", "aria-hidden": "true" },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.lockScreenForm.password,
                                  expression: "lockScreenForm.password",
                                },
                              ],
                              staticClass: "auth-saas__input",
                              attrs: {
                                id: "lock-password",
                                type: "password",
                                name: "password",
                                autocomplete: "current-password",
                                placeholder: _vm.trans("auth.password"),
                              },
                              domProps: { value: _vm.lockScreenForm.password },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.lockScreenForm,
                                    "password",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("show-error", {
                          staticClass: "text-danger",
                          attrs: {
                            "form-name": _vm.lockScreenForm,
                            "prop-name": "password",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group mb-0" }, [
                      _c(
                        "button",
                        {
                          staticClass: "auth-saas__btn",
                          attrs: {
                            type: "submit",
                            disabled: _vm.lockScreenForm.busy,
                          },
                        },
                        [
                          _vm.lockScreenForm.busy
                            ? _c("span", {
                                staticClass: "auth-saas__btn-spinner",
                                attrs: { "aria-hidden": "true" },
                              })
                            : _c("admin-icon", {
                                attrs: {
                                  name: "arrow-right",
                                  "aria-hidden": "true",
                                },
                              }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.trans("auth.confirm"))),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "auth-saas__note" }, [
                  _c(
                    "a",
                    {
                      staticClass: "auth-saas__link-muted",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("admin-icon", { attrs: { name: "logout" } }),
                      _vm._v(" " + _vm._s(_vm.trans("auth.logout"))),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "auth-saas__footer" },
              [_c("guest-footer")],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center mb-2" }, [
      _c("span", { staticClass: "auth-saas__eyebrow" }, [
        _vm._v("Screen locked"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-saas__mini-chip" }, [
      _c("span", {
        staticClass: "auth-saas__status-chip-dot",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Session locked")]),
      _vm._v(" "),
      _c("kbd", [_vm._v("Verify")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }